<div class="modal active navaidSitingTool">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>NavAid Siting Tool Options</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngNavaidSitingToolForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Calculation Name</label>
                  <input name="calculationName" type="text" [(ngModel)]="this.model.name" [required]="true"
                  forbiddenSubstring={{forbiddenSubstringName}} alphaNumeric #calculationName="ngModel"/>
                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                    Name cannot contain {{forbiddenSubstringName}}.
                  </span>
                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                    Only alphanumeric characters, hyphens and underscores are allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Options</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Siting Results</label>
                  <select
                    [(ngModel)]="this.model.sitingResults"
                    name="sitingResults"
                    id="sitingResults"
                  >
                    <option value="Full">Full Results</option>
                    <option value="ExcludeWater">Exclude Water</option>
                  </select>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <input id="visibilityAnalysis" name="visibilityAnalysis" type="checkbox" [checked]="this.model.visibilityAnalysis" [(ngModel)]="this.model.visibilityAnalysis"/>
                  <label for="">Visibility Analysis</label>
                </div>
                <div>
                  <label for="">Flight Level</label>
                  <div class="coordenates">
                    <input id="flightLevelFt" name="flightLevelFt" type="number" [(ngModel)]="this.model.flightLevel"
                    (ngModelChange)="this.model.flightLevelMeters=this.utilsService.feetToMeters($event)"
                    style="width: 30%" [required]="this.model.visibilityAnalysis" [disabled]="!this.model.visibilityAnalysis"/>
                    <span>[ft]</span>
                    <input id="flightLevelMeters" name="flightLevelMeters" [(ngModel)]="this.model.flightLevelMeters"
                    (ngModelChange)="this.model.flightLevel=this.utilsService.metersToFeet($event)"
                    type="number" style="width: 30%" [required]="this.model.visibilityAnalysis" [disabled]="!this.model.visibilityAnalysis"/>
                    <span>[m]</span>
                  </div>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Sector Cell Height</label>
                  <select
                    style="width: 100%; max-width: max-content;"
                    [(ngModel)]="this.model.sectorCellHeight"
                    name="sectorCellHeight"
                    id="sectorCellHeight"
                    [required]="this.model.visibilityAnalysis"
                    [disabled]="!this.model.visibilityAnalysis"
                  >
                    <option value="Minimum">Consider Minimum Terrain Height</option>
                    <option value="Maximum">Consider Maximum Terrain Height</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>NavAid Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">DOC</label>
                  <input id="doc" name="doc" type="number" [(ngModel)]="this.model.doc"/>
                </div>
                <div>
                  <label for="">Min Subtended Angle</label>
                  <input
                    id ="minSubtendedAngle"
                    name="minSubtendedAngle"
                    type="number"
                    [(ngModel)]="this.model.minSubtendedAngle"
                    (change)= "this.setSubtendedAngleValue($event.target.value)"
                    [required]="true"
                    min="0"
                    max="90"
                    />
                </div>
                <div>
                  <label for="">Max Subtented Angle</label>
                  <input id="maxSubtendedAngle" name="maxSubtendedAngle" type="number" [(ngModel)]="this.model.maxSubtendedAngle" [disabled]="true" [required]="true"/>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="calculate()"
              [disabled]="!ngForm.form.valid"
            >Ok</button>
            <button class="gray" type="button" (click)="redraw()" value="Redraw">Redraw Area</button>
            <button class="gray" type="button" (click)="cancel()" value="Cancel">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
